import _ from 'lodash'
import { SearchTree, ValidateCharacters } from "../../../constants/ProConstants";

const BedValidator = ({model}, treeData)=>{ 

    let errors = {};
    
    if (_.isEmpty(model.location)) {           
        errors.location = "Please choose location.";
    }
    if (_.isEmpty(model.building)) {              
            errors.building = "Please choose building.";
    }
    if (_.isEmpty(model.room)) {              
        errors.room = "Please choose room.";
    }
    if (_.isEmpty(model.name)) {               
            errors.name = "Bed name is required.";
    }
    if (!_.isEmpty(model.name) && model.name.length > 120) {              
        errors.name = "Max 120 characters allowed";
    } 
    if (!_.isEmpty(model.name) && !ValidateCharacters(model.name)) {              
        errors.name = "Invalid Characters";
    }
    if(_.get(model.parentType, "code") && !_.isEqual(model.parentType.code, "BUILDING"))
    {
        if(_.isNull(model.parent)){
            errors.parent = `Please choose ${model.parentType.name}`;
        }
    }  
    if(_.get(model.building, "name") && _.get(model.room, "key"))  {  
        var element =  SearchTree(SearchTree(treeData, "key", model.room.key), "label", `${model.name}`);
        if(!_.isNull(element) && element.key !== model.key)
            errors.name =  "Bed name already exists!";
    }
        
    return errors;

}

export default BedValidator;